module.exports = __webpack_public_path__ + "static/img/home_gg_2_backup.02fecf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_gg_2_backup.png
// module id = ItgY
// module chunks = 1